import { useEffect, useState } from "react";
import Header from "@components/Header";
import Footer from "@components/Footer";
import useHomeData from "@features/home/hooks/useHomeData";
import ComingSoonSection from "@sections/home/ComingSoonSection";
import ContinueWatchingSection from "@sections/home/ContinueWatchingSection";
import ForYouSection from "@sections/home/ForYouSection";
import GenreSubscriptionSections from "@sections/home/GenreSubscriptionSections";
import GenresSection from "@sections/home/GenresSection";
import HeroSection from "@sections/home/HeroSection";
import NewSubscriptionSection from "@sections/home/NewSubscriptionSection";
import PatternOfferBanner from "@sections/home/PatternOfferBanner";
import PremieresBanner from "@sections/home/PremieresBanner";
import ShowcaseSection from "@sections/home/ShowcaseSection";
import TopSevenSection from "@sections/home/TopSevenSection";
import { authApi, mediaUrl } from "@services/contentApi";

const formatPlaybackTime = (seconds = 0) => {
  const value = Math.max(0, Math.floor(Number(seconds) || 0));
  const hours = Math.floor(value / 3600);
  const minutes = Math.floor((value % 3600) / 60);
  const secs = value % 60;
  return `${hours ? `${hours}:` : ""}${hours ? String(minutes).padStart(2, "0") : minutes}:${String(secs).padStart(2, "0")}`;
};

export default function SmotriPage() {
  const { homeData } = useHomeData();
  const [continueWatching, setContinueWatching] = useState([]);

  useEffect(() => {
    let active = true;
    authApi.watchProgress().then((items) => {
      if (!active) return;
      setContinueWatching(items.map((item) => {
        const content = item.content;
        const episode = content.type === "series"
          ? content.seasons?.flatMap((season) => season.episodes.map((episodeItem) => ({ ...episodeItem, seasonNumber: season.seasonNumber }))).find((episodeItem) => episodeItem._id === item.episodeId)
          : null;
        return {
          id: `${content._id}-${item.episodeId || "movie"}`,
          href: `/watch/${content._id}`,
          title: episode ? `${content.title} · S${episode.seasonNumber}E${episode.episodeNumber}` : content.title,
          duration: `${formatPlaybackTime(item.position)} / ${formatPlaybackTime(item.duration)}`,
          progress: Math.min(100, Math.round(item.position / item.duration * 100)),
          img: mediaUrl(content.backdropUrl || content.posterUrl),
        };
      }));
    }).catch(() => active && setContinueWatching([]));
    return () => { active = false; };
  }, []);

  return (
    <div className="home-page"
      style={{
        background: "#000000",
        minHeight: "100vh",
        fontFamily: "'Jost', sans-serif",
        color: "#fff",
      }}
    >
      <Header />
      <HeroSection slides={homeData.heroSlides} />

      {continueWatching.length > 0 && <ContinueWatchingSection items={continueWatching} />}
      <NewSubscriptionSection items={homeData.newInSubscription} />

      {homeData.comingSoon.length > 0 && <ComingSoonSection items={homeData.comingSoon} />}
      <TopSevenSection items={homeData.topSeven} />

      <PremieresBanner />
      <GenresSection items={homeData.genres} />
      <PatternOfferBanner />
      {homeData.forYou.length > 0 && <ForYouSection items={homeData.forYou} />}

      <ShowcaseSection />
      <GenreSubscriptionSections sections={homeData.genreSections} />
      <Footer />
      <style>{`
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { display: none; }
        [style*="scrollbarWidth"] { scrollbar-width: none; }
      `}</style>
    </div>
  );
}
